module.exports = __webpack_public_path__ + "static/img/northFaceTop.4c281ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/northFaceTop.png
// module id = MLE4
// module chunks = 2